export const gamesData = [
  {
    id: 1,
    name: "Card Slam | Play Together",
    link: "https://card-slam.netlify.app/",
    github: "https://github.com/Website-Slammers/card-slam",
    description: "Group project: sleek website hosting several cards games including Hearts and Spades. This site aims to host a variety of game options and hopefully the ability to host mulitplayer games across different computers.",
    group: true,
    stack: "React.js | SCSS | Netlify"
  },
  {
    id: 2,
    name: "Sudoku",
    link: "https://sudoku-slam.netlify.app/",
    github: "https://github.com/Website-Slammers/Su-Do-Ku",
    description: "Group project: tranquil sudoku webpage. Sudoku is a logic-based, combinatorial number placement puzzle. In classic Sudoku, the objective is to fill a 9 x 9 grid with digits so that each column, row, and each of the nine 3 x 3 subgrids contain digits 1 to 9.",
    group: true,
    stack: "React.js | SCSS | Netlify"
  },
  {
    id: 3,
    name: "Curse of Strahd: Durst Manor",
    link: "https://death-house.drewford.dev/",
    github: "https://github.com/SleazyCook/Durst-Manor",
    description: "A multiple choice adventure game based on the introduction to the popular Curse of Strahd campagin setting from Dungeons and Dragons. To start you will choose a character ability: Strength, Dexterity, Charisma, or Luck. Use your ability to navigate through Durst Manor to uncover the truth and get out alive!",
    group: false,
    stack: "HTML | CSS | JavaScript | Netlify"    
  },
  {
    id: 4,
    name: "Pokemon Picker",
    link: "https://gotta-pick-em-all.netlify.app/",
    github: "https://github.com/Website-Slammers/PokemonPicker",
    description: "Team project inspired by either.io, Pokemon Picker offers you the chance to rank your favorite pokemon by choosing between two randomly selected pokemon at a time. Choose which generation you are interested in ranking and view your statistics based on wins, type, and generation.",
    group: true,
    stack: "React.js | CSS | API | Netlify"
  },
  {
    id: 5,
    name: "Connect 4",
    link: "https://connect4bydrewford.netlify.app/",
    github: "https://github.com/SleazyCook/project_03",
    description: "Connect-Four is a tic-tac-toe-like two-player game in which players alternately place pieces on a vertical board 7 columns across and 6 rows high.",
    group: false,
    stack: "HTML | CSS | JavaScript | Netlify"
  },
  {
    id: 6,
    name: "Pixelate",
    link: "https://pixel8game.netlify.app/",
    github: "https://github.com/SleazyCook/pixelate_asignment",
    description: "Add rows and choose from 12 different colors to create your own pixel art.",
    group: false,
    stack: "HTML | CSS | JavaScript | Netlify"
  },
  {
    id: 7,
    name: "Puppy Clicker",
    link: "https://puppy-clicker.netlify.app/",
    github: "https://github.com/SleazyCook/project_02",
    description: "A cute incremental, or clicker, game with a puppy theme! Click or tap the puppy icon to start building resources and use those resources to purchase passive producers until you have a ridiculous amount of puppies!",
    group: false,
    stack: "HTML | CSS | JavaScript | Netlify"
  }
]